import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EventsDisplay from '../components/EventsDisplay';

const styles = `
.agendamento-page {
  min-height: 100vh;
  background-color: white;
}

.agendamento-hero {
  padding: 4rem 0 3rem;
  background: linear-gradient(to bottom, #f0f9f9, white);
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

.agendamento-title {
  font-size: 3rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
  letter-spacing: 0.025em;
}

.agendamento-subtitle {
  text-align: center;
  color: #4A8080;
  max-width: 800px;
  margin: 0 auto 2rem;
  font-size: 1.125rem;
  line-height: 1.8;
}

.servicos-section {
  padding: 5rem 0;
  background-color: white;
}

.section-title {
  font-size: 2.5rem;
  color: #5A9C9C;
  text-align: center;
  margin-bottom: 3rem;
  font-weight: 300;
}

.servicos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.servico-card {
  background-color: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
}

.servico-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.servico-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
  background-color: #f3f4f6;
}

.servico-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.servico-content {
  padding: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.servico-content h3 {
  font-size: 1.5rem;
  color: #4A8080;
  margin-bottom: 1rem;
}

.servico-description {
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 1rem;
  flex: 1;
}

.servico-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.servico-duracao,
.servico-preco {
  color: #4b5563;
  font-size: 0.95rem;
}

.servico-preco {
  font-size: 1.5rem;
  color: #5A9C9C;
  font-weight: 600;
}

.servico-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.servico-btn:hover {
  background-color: #3A6666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background-color: white;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
  position: relative;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  background-color: #4A8080;
  color: white;
  padding: 2rem;
  position: relative;
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.5rem;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s;
}

.modal-close-btn:hover {
  opacity: 0.7;
}

.modal-title {
  font-size: 1.75rem;
  margin: 0;
  font-weight: 300;
}

.modal-body {
  padding: 2rem;
}

.agendamento-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}

.form-group input,
.form-group textarea,
.form-group select {
  padding: 0.875rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #5A9C9C;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.submit-btn {
  width: 100%;
  padding: 1rem;
  background-color: #4A8080;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 1rem;
}

.submit-btn:hover {
  background-color: #3A6666;
}

.form-note {
  font-size: 0.875rem;
  color: #6b7280;
  font-style: italic;
  text-align: center;
}

.info-section {
  padding: 5rem 0;
  background-color: #f9fafb;
}

.info-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.info-title {
  font-size: 2rem;
  color: #5A9C9C;
  margin-bottom: 1.5rem;
  font-weight: 300;
}

.info-text {
  color: #4b5563;
  line-height: 1.8;
  font-size: 1.0625rem;
  margin-bottom: 1rem;
}

.info-highlight {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  border-left: 4px solid #5A9C9C;
  margin-top: 2rem;
}

.info-highlight h3 {
  font-size: 1.25rem;
  color: #4A8080;
  margin-bottom: 1rem;
}

.info-highlight p {
  color: #4b5563;
  line-height: 1.6;
  margin: 0.5rem 0;
}

@media (max-width: 768px) {
  .agendamento-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .servicos-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .modal-header {
    padding: 1.5rem;
  }

  .modal-body {
    padding: 1.5rem;
  }
}
`;

export default function AgendamentoPage() {

  const servicos = [
    {
      id: 1,
      nome: 'Brincoteca - Hora da brincadeira',
      descricao: 'Deixe os seus filhos terem experiências com liberdade total para brincarem e aprenderem com muita imaginação.',
      duracao: '1 h',
      preco: '5 €',
      imagem: '/assets/image5.png',
      detalhes: {
        titulo: 'Brincoteca - Hora da brincadeira',
        preco: '5 €',
        duracao: '1 hora',
        descricao: 'Filipa Ferreira',
      }
    },
    {
      id: 2,
      nome: 'Festa de aniversário',
      descricao: 'Vem comemorar/ conhecer a tua festa de aniversário e traz os teus amigos! Proporcionamos festas únicas e memoráveis.',
      duracao: '2 h 30 min',
      preco: '18 € por participante',
      imagem: '/assets/image6.png',
      detalhes: {
        titulo: 'Festa de aniversário',
        preco: '18 €',
        precoPorParticipante: 18,
        duracao: '2 horas e 30 minutos',
        descricao: 'Filipa Ferreira',
        participantesObrigatorio: true
      }
    }
  ];

  return (
    <>
      <style>{styles}</style>
      <div className="agendamento-page">
        <section className="agendamento-hero">
          <div className="container">
            <h1 className="agendamento-title">Agendamento Online</h1>
            <p className="agendamento-subtitle">
              Escolha o serviço que deseja e solicite o seu agendamento. 
              Entraremos em contacto para confirmar a disponibilidade.
            </p>
          </div>
        </section>

        <EventsDisplay showTitle={true} limit={null} />

        <section className="servicos-section">
          <div className="container">
            <h2 className="section-title">Nossos serviços</h2>
            
            <div className="servicos-grid">
              {servicos.map((servico) => (
                <div key={servico.id} className="servico-card">
                  <div className="servico-image">
                    <img src={servico.imagem} alt={servico.nome} />
                  </div>
                  <div className="servico-content">
                    <h3>{servico.nome}</h3>
                    <p className="servico-description">{servico.descricao}</p>
                    <div className="servico-info">
                      <p className="servico-duracao">Duração: {servico.duracao}</p>
                      <p className="servico-preco">{servico.preco}</p>
                    </div>
                    <Link 
                      className="servico-btn"
                      to="/booking-calendar"
                      state={{ selectedServico: servicos[servico.id - 1]}}
                    >
                      Solicitar agendamento
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}